<template>
    <div role="tabcard" class="tab-pane" id="draft-selections">
        <draft-selection-list :role="role" :user="user" :project="project"></draft-selection-list>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'project'],

        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        watch: {
        },

        computed: {
            
        },

        methods: {
        }
    }
</script>
